import React from 'react';
import './Common.Widget.css';

export default function CommonWidget({ values, additionalInfo }) {
  const [value = '-'] = values;
  return (
    <div className="common-widget-wrapper">
      <span className="common-widget-value">
        <p>{value}</p>
        <p>{additionalInfo.unit}</p>
      </span>
      <p>{additionalInfo.name}</p>
    </div>
  );
}
